var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.5H2.5C1.255 0.5 0.25 1.4975 0.25 2.7275V10.91C0.25 12.14 1.255 13.1375 2.5 13.1375H3.07C3.67 13.1375 4.24 13.37 4.66 13.79L5.9425 15.0575C6.5275 15.635 7.48 15.635 8.065 15.0575L9.3475 13.79C9.7675 13.37 10.345 13.1375 10.9375 13.1375H11.5C12.745 13.1375 13.75 12.14 13.75 10.91V2.7275C13.75 1.4975 12.745 0.5 11.5 0.5ZM7 3.3125C7.9675 3.3125 8.7475 4.0925 8.7475 5.06C8.7475 6.0275 7.9675 6.8075 7 6.8075C6.0325 6.8075 5.2525 6.02 5.2525 5.06C5.2525 4.0925 6.0325 3.3125 7 3.3125ZM9.01 10.295H4.99C4.3825 10.295 4.03 9.62 4.3675 9.1175C4.8775 8.36 5.8675 7.85 7 7.85C8.1325 7.85 9.1225 8.36 9.6325 9.1175C9.97 9.62 9.61 10.295 9.01 10.295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleActive);
export default __webpack_public_path__ + "static/media/role-active.bd49d98b511409cf25f48234fb132b5e.svg";
export { ForwardRef as ReactComponent };